import React, { useEffect, useMemo, useState } from "react";

import { getAgencies } from "common/services/agencies.service";
import { normalize } from "common/lib/normalize";
import { FilterSelect } from "Components/Common/TableFilters";
import {
  PSEA_RATING_FULL,
  PSEA_RATING_LOW,
  PSEA_RATING_MEDIUM,
} from "./pseaScoring";

/**
 * Filter dropdowns for the PSEA assessments table. Both are plain
 * `{ value, label }` selects so the table's URL round-trip can serialise them.
 */

type FilterProps = {
  value: any;
  onChange: (value: any) => void;
};

export const AgencyFilter = ({ value, onChange }: FilterProps) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response: any = await getAgencies({
          pagination: { page: 1, pageSize: 10000 },
          filters: { category: { $null: false } },
          sort: ["name"],
        });
        setData(normalize(response.data));
      } catch (e) {
        // no-op
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(
    () => data.map((el: any) => ({ value: el?.id, label: el?.name })),
    [data]
  );

  return (
    <FilterSelect
      id="agencyFilter"
      placeholder="Filter by agency"
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
    />
  );
};

/**
 * Ratings are derived capacity bands rather than records, so the options are
 * the fixed set and the filter value is the rating text itself.
 */
const RATING_OPTIONS = [
  PSEA_RATING_FULL,
  PSEA_RATING_MEDIUM,
  PSEA_RATING_LOW,
].map((rating) => ({ value: rating, label: rating }));

export const OverallRatingFilter = ({ value, onChange }: FilterProps) => (
  <FilterSelect
    id="overallRatingFilter"
    placeholder="Filter by overall rating"
    value={value}
    onChange={onChange}
    options={RATING_OPTIONS}
  />
);
